import { Patient, Slot } from "@cur8/rich-entity";
import { useNav } from "@pomle/react-router-paths";
import { ReactComponent as EightCornerStarIcon } from "assets/eight-corner-star.svg";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { paths } from "render/routes/paths";
import { Typography } from "render/ui/presentation/Typography";
import { BigButton } from "render/ui/trigger/BigButton";
import { FadeIn } from "render/views/HomeView/components/_shared/FadeIn";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

interface BookingUpcomingStageProps {
  patient: Patient;
  slot: Slot;
}

export function BookingUpcomingStage({
  patient,
  slot,
}: BookingUpcomingStageProps) {
  const nav = {
    appointment: useNav(paths.appointment),
  };
  const time = useMemo(() => {
    const format = "HH:mm";
    const timeZoneId = slot.room?.site?.timeZoneId;
    const start = slot.startTime.setZone(timeZoneId);
    const end = slot.endTime.setZone(timeZoneId);

    return `${start.toFormat(format)} - ${end.toFormat(format)}`;
  }, [slot]);
  const date = useMemo(() => {
    const timeZoneId = slot.room?.site?.timeZoneId;
    const start = slot.startTime.setZone(timeZoneId);

    const isDifferentYear = start.year !== DateTime.now().year;

    return start.toFormat(`d MMMM${isDifferentYear ? " yyyy" : ""}`);
  }, [slot]);

  return (
    <div className={styles.BookingUpcomingStage}>
      <FadeIn offset={112}>
        <Typography variant="display-s">
          <Trans.Greeting patient={patient} />
        </Typography>
      </FadeIn>
      <FadeIn offset={176}>
        <BigButton onClick={nav.appointment.on({ slotId: slot.slotId })}>
          <div className={styles.button}>
            <EightCornerStarIcon />
            <div className={styles.text}>
              <Typography variant="body-label-m" color="default">
                <Trans.ScanBooked />
              </Typography>
              <Typography variant="body-s">
                {time} • {date}
              </Typography>
            </div>
          </div>
        </BigButton>
      </FadeIn>
    </div>
  );
}
